import { VideoCallAction, AgoraMuteVideoAction, AgoraUnmuteVideoAction } from 'components/features/videoCalls/types/actions'
import { agoraInstances } from 'components/features/videoCalls/agoraInstances'
import { EpicRefined } from 'interfaces/middleware'
import { mergeMapAsync } from 'rxOperators/mergeMapAsync'
import { mergeMap, catchError } from 'rxjs/operators'
import { of, merge } from 'rxjs'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'


export const muteVideoEpic: EpicRefined<VideoCallAction> = (action$, store) => action$.pipe(
  filterRequestOfType(AgoraMuteVideoAction.type, 'request'),
  mergeMap((action) => {
    const { videoCall } = store.getState().app
    const { state } = videoCall.client
    if (state !== 'active') {
      return of(action.success())
    }

    const { streamId } = videoCall.localStream
    const stream = agoraInstances.streams.get(streamId as any)
    if (!stream) {
      return of(action.fail())
    }

    if (!stream.muteVideo()) {
      return of(action.fail())
    }

    return of(action.success())
  }),
)

export const unmuteVideoEpic: EpicRefined<VideoCallAction> = (action$, store) => action$.pipe(
  filterRequestOfType(AgoraUnmuteVideoAction.type, 'request'),
  mergeMap((action) => of(null).pipe(

    mergeMapAsync(async () => {
      const { videoCall } = store.getState().app
      const { state } = videoCall.client
      if (state !== 'active') {
        return [action.success()]
      }

      const { streamId } = videoCall.localStream
      const stream = agoraInstances.streams.get(streamId as any)
      if (!stream) {
        return [action.fail()]
      }

      if (!stream.unmuteVideo()) {
        return [action.fail()]
      }
      return [action.success()]
    }),
    mergeMap((actions: VideoCallAction[]) => merge(...actions.map((item) => {
      // prevent code collapse
      return of(item)
    }))),
    catchError(() => of(action.fail())),
  ))
)
